export default __webpack_public_path__ + "static/media/logo-icon.eefb6b06.png";